import { render, staticRenderFns } from "./PartDetails.vue?vue&type=template&id=c2198170"
import script from "./PartDetails.ts?vue&type=script&lang=ts&external"
export * from "./PartDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./PartDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports